import {
  computeDynamicRangeFromNormalizationOrChannelHistogram,
  useMultiplexSlideChannelNormalizationData,
  useMultiplexSlideChannelNormalizationsOptions,
} from 'components/Procedure/SlideControls/Multiplex/channelNormalizations';
import { Slide } from 'interfaces/slide';
import React from 'react';
import ImageWithAdjustedLevels, { adjustmentSettingsPresets, getImageBitDepth } from './ImageWithAdjustedLevels';

const getDnaChannelIndexFromSlide = (slide: Slide): number | undefined => {
  try {
    if (slide?.dnaChannelId !== undefined && slide?.dnaChannelId !== null) {
      return Number(slide.dnaChannelId);
    }

    return undefined;
  } catch (e) {
    console.error('Error getting channel data from slide', e);
    return undefined;
  }
};

interface MultiplexSlideImageProps {
  imageUrl: string;
  handleImageError: () => void;
  slide: Slide;
}

const MultiplexSlideImage: React.FC<MultiplexSlideImageProps> = ({ imageUrl, handleImageError, slide }) => {
  const bitDepth: 8 | 16 = getImageBitDepth(slide?.encoding, imageUrl);
  const colorAdjustmentSettings = adjustmentSettingsPresets.multiplex[bitDepth];

  const { defaultNormalization } = useMultiplexSlideChannelNormalizationsOptions({ slide });
  const defaultNormalizationExperimentResultId = defaultNormalization?.experimentResultId ?? 0;
  const { normalizationData } = useMultiplexSlideChannelNormalizationData(
    slide,
    defaultNormalizationExperimentResultId,
    Boolean(defaultNormalization?.experimentResultId)
  );
  if (normalizationData) {
    const dnaChannelIndexFromChannelData = getDnaChannelIndexFromSlide(slide);
    const dynamicRange = computeDynamicRangeFromNormalizationOrChannelHistogram(
      dnaChannelIndexFromChannelData ?? 0,
      normalizationData,
      bitDepth === 16
    );
    colorAdjustmentSettings.blackPoint = dynamicRange[0];
    colorAdjustmentSettings.whitePoint = dynamicRange[1];
  }

  return (
    <ImageWithAdjustedLevels
      src={imageUrl}
      onError={handleImageError}
      bitDepth={bitDepth}
      {...(colorAdjustmentSettings || {})}
    />
  );
};

export default MultiplexSlideImage;
